export default "__VITE_ASSET__Ci21ZyEZ__"